$( document ).ready(function() {
    var checkExist = setInterval(function() {
        var $item = $('select[name="country_code"] option');
        if ($item.length) {
           clearInterval(checkExist);

           $('.element-group input').each(function() { //Get every input in the "select-option" div
                var t = $(this);
                var l = t.siblings('label'); //Find the closest label
                l.appendTo(t.parents('.element-group'));
            });

            $( 'select[name="country_code"] option' ).each(function(){
                var mySubString = $(this).text().substring(
                    $(this).text().indexOf("(") + 1, 
                    $(this).text().lastIndexOf(")")
                );
                $(this).val(mySubString);
            })
            var $selectCountryCode = $( 'select[name="country_code"]' );
            $selectCountryCode.prepend("<option value='+61' selected>Australia (+61)</option>").val('+61');
            $selectCountryCode.find( "option:first" ).text($selectCountryCode.val() ).val( $selectCountryCode.val() ).prop( 'selected', true );
            $( 'select[name="country_code"]' ).change( function(){
                var $this = $( this );
                var $dataCountry = $this.find(':selected').attr('data-countrycode');
                console.log($this.find(':selected').val());
                $this.find( "option:first" ).text($this.val() ).val( $this.val() ).prop( 'selected', true );
            })

            $('.cs-form-wrap button[type="submit"]').click(function(){
                var checkFormSubmitting = setInterval(function() {
                    var $item = $('.blockUI.blockOverlay');
                    if ($item.length) {
                        clearInterval(checkFormSubmitting);
                        if($(window).width() <= 899){
                            $('.cs-form-wrap button[type="submit"]').addClass('u-loading');
                            var checkFormSubmittingComplete = setInterval(function() {
                                var $item2 = $('.blockUI.blockOverlay');
                                if (!$item2.length) {
                                    clearInterval(checkFormSubmittingComplete);
                                    if($(window).width() <= 899){
                                        $('.cs-form-wrap button[type="submit"]').removeClass('u-loading');
                                    }
                                }
                            }, 100); // check every 100ms
                        }
                    }
                }, 100); // check every 100ms
            })
        }
    }, 100); // check every 100ms

    $('.c-pop-up-book-now__close-button').click(function(){
        $('#shopify-section-pop-up-book-now').addClass('d-none');
    })

    $('.c-booking-btn').click(function(e){
        e.preventDefault();
        $('#shopify-section-pop-up-book-now').removeClass('d-none');
    })
});